import { FormEvent, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const VIP_SIGNUP_URL = "https://vivamelbourne.com.au/wp-admin/admin-ajax.php?action=viva_submit_vip_signup";

interface Props {
  isOpen: boolean;
  modalToggler: (isOpen: boolean) => void;
}

type Status = { type: "success" | "error"; message: string } | null;

function VipSignupModal({ isOpen, modalToggler }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<Status>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    setIsSubmitting(true);
    setStatus(null);

    try {
      const response = await fetch(VIP_SIGNUP_URL, { method: "POST", body: new FormData(form) });
      const data = await response.json();

      if (data.success) {
        setStatus({ type: "success", message: "Welcome to VIVA VIP! Check your inbox soon." });
        form.reset();
      } else {
        setStatus({
          type: "error",
          message: typeof data.data === "string" ? data.data : "Something went wrong. Please try again.",
        });
      }
    } catch {
      setStatus({ type: "error", message: "Something went wrong. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => modalToggler(!isOpen)}
      className="modal-dialog-centered modal-vip animate__animated animate__zoomIn animate__fast"
      fade={false}
      onClosed={() => setStatus(null)}
    >
      <div className="modal-content-wrapper">
        <ModalHeader toggle={() => modalToggler(!isOpen)} className="z-3">
          JOIN VIVA VIP
        </ModalHeader>
        <ModalBody className="pt-0">
          <p className="c-vip-form__intro">Enter your details below for exclusive event access & secret pre-sales.</p>

          <form className="c-vip-form" onSubmit={handleSubmit} noValidate>
            <input type="hidden" name="action" value="viva_submit_vip_signup" />
            <input type="hidden" name="occasion" value="VIP Membership Signup" />

            <div className="c-vip-form__group">
              <label htmlFor="vip-name">Full Name *</label>
              <input type="text" id="vip-name" name="name" placeholder="e.g. Sarah Jenkins" autoComplete="name" required />
            </div>

            <div className="c-vip-form__group">
              <label htmlFor="vip-email">Email Address *</label>
              <input
                type="email"
                id="vip-email"
                name="email"
                placeholder="sarah@example.com"
                autoComplete="email"
                required
              />
            </div>

            <div className="c-vip-form__group">
              <label htmlFor="vip-phone">Phone Number *</label>
              <input type="tel" id="vip-phone" name="phone" placeholder="0400 000 000" autoComplete="tel" required />
            </div>

            <button type="submit" className="c-vip-form__submit" disabled={isSubmitting}>
              {isSubmitting ? "Joining VIP..." : "Unlock VIP Access"}
            </button>

            {status && (
              <div className={`c-vip-form__status ${status.type}`} role="status">
                {status.message}
              </div>
            )}
          </form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default VipSignupModal;
